import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
import { KTIcon } from "../../../../_metronic/helpers";
import { PageHeader } from "../../../components/common/pageHeader/PageHeader";
import { EmptySection } from "../../../components/sections/empty/Empty";
import { LoaderSection } from "../../../components/sections/loader/Loader";
import { useDeleteModal } from "../../../context/DeleteModalContext";
import { PLACEHOLDER_IMAGE_URL } from "../../../mock/constants";
import { URL_TEAM_MEMBER_CREATE } from "../../../mock/page_urls";
import { MODERATOR_ABOUT_TEAM } from "../../../mock/URLs";
import { getTeamMembers } from "../../../services/aboutTeamSvc";
import imgBaseUrl from "../../../utils/imgBaseUrl";
import { separateFormatter } from "../../../utils/separateFormatter";

const TeamPage = () => {
    const navigate = useNavigate()
    const { data: team, isLoading: teamIsLoading, isError: teamIsError, refetch: refetchTeam } = useQuery("getTeamMembers", getTeamMembers)

    const pageDetails = {
        title: "Loyiha a'zolari",
        desc: `Jami loyiha a'zolari soni: (${separateFormatter(team?.length || 0, " ", "ta")})`,
        buttons: [{
            onClick: () => navigate(URL_TEAM_MEMBER_CREATE),
            text: "Qo'shish",
            icon: "plus-square",
        }]
    };

    const { openDeleteModal } = useDeleteModal()

    const handleDeleteClick = (id: number) => {
        openDeleteModal(MODERATOR_ABOUT_TEAM, id, refetchTeam);
    };

    if (teamIsError) {
        return <EmptySection height={"50vh"} />
    }

    if (teamIsLoading) {
        return <LoaderSection height={"50vh"} />
    }

    return (
        <div>
            <PageHeader pageDetails={pageDetails} />
            <div className="row g-6 mb-6 g-xl-9 mb-xl-9">
                {
                    teamIsLoading ? <LoaderSection height={"50vh"} /> : team?.length === 0 ? <EmptySection height={"50vh"} /> : team?.map(member => (
                        <div key={member?.id} className="col-md-6 col-xxl-3">
                            <div className="card h-100 text-center">
                                <div className="card-body d-flex flex-center flex-column py-9 px-5">
                                    <div className="symbol symbol-65px symbol-circle mb-5">
                                        <img className="object-fit-cover" src={imgBaseUrl(member?.image!) || PLACEHOLDER_IMAGE_URL} alt={`${member?.full_name}`} />
                                        <div className="bg-success position-absolute rounded-circle translate-middle start-100 top-100 border border-4 border-body h-15px w-15px ms-n3 mt-n3"></div>                    </div>
                                    <span className="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{member?.full_name}</span>
                                    <h6 className="fw-semibold text-gray-500 mb-6 mt-2">{member?.title}</h6>
                                    <div className="d-flex gap-2">
                                        <Link to={`/team/update/${member?.id}`} className={"btn btn-sm btn-light-primary"}>
                                            <KTIcon iconName={"pencil"} className={"fs-4"} />
                                            Tahrirlash
                                        </Link>
                                        <button className="btn btn-icon btn-danger btn-sm me-1" onClick={() => {
                                            handleDeleteClick(member.id)
                                        }}>
                                            <KTIcon iconName={"trash-square"} className={"pe-0 fs-3"} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default TeamPage